import React from 'react';

export default props => (
    <div
        style={{
            position: 'absolute',
            bottom: '32px',
            left: 0,
            right: 0,
            zIndex: 99,
            textAlign: 'center'
        }}
        {...props}
    >
        <div
            style={{
                borderRadius: '4px',
                background: 'rgb(98, 0, 255)',
                padding: '8px 16px',
                fontSize: '14px',
                color: 'white',
                display: 'inline-block',
                fontWeight: '500',
                boxShadow: 'rgba(36, 18, 77, 0.4) 0px 16px 24px -8px'
            }}
        >
            {props.children}
        </div>
    </div>
);
